function formatEmMoney(cents) {
  if (window.Shopify?.formatMoney) {
    const format = window.theme?.moneyFormat || window.Shopify.money_format || '${{amount}}';
    return Shopify.formatMoney(cents, format);
  }
  return (cents / 100).toFixed(2);
}

function showGalleryByMediaId(galleryRoot, mediaId) {
  if (!galleryRoot || !mediaId) return;
  const slides = Array.from(galleryRoot.querySelectorAll('[data-em-gallery-slide]'));
  const thumbs = Array.from(galleryRoot.querySelectorAll('[data-em-gallery-thumb]'));
  let index = slides.findIndex((slide) => Number(slide.dataset.mediaId) === Number(mediaId));
  if (index < 0) return;

  slides.forEach((slide, idx) => {
    const active = idx === index;
    slide.classList.toggle('is-active', active);
    slide.hidden = !active;
  });
  thumbs.forEach((thumb, idx) => {
    thumb.classList.toggle('is-active', idx === index);
  });
}

function initEarthMakerProduct(el) {
  if (el.dataset.emProductInit === 'true') return;
  el.dataset.emProductInit = 'true';

  const form = el.querySelector('[data-em-product-form]');
  if (!form) return;

  const variantsEl = form.querySelector('[data-em-variants-json]');
  const mediaMapEl = form.querySelector('[data-em-variant-media-map]');
  const variantInput = form.querySelector('[data-em-variant-id]');
  const optionInputs = form.querySelectorAll('[data-em-option]');
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const mediaMap = mediaMapEl ? JSON.parse(mediaMapEl.textContent) : {};
  const priceEl = el.querySelector('[data-em-price]');
  const stickyPriceEl = el.querySelector('[data-em-sticky-price]');
  const stickyBar = el.querySelector('[data-em-sticky-atc]');
  const stickySubmit = el.querySelector('[data-em-sticky-submit]');
  const galleryRoot = el.matches('[data-em-gallery]') ? el : el.querySelector('[data-em-gallery]') || el;
  const swatchSelectors = '.em-product__swatch-label, .em-product__pill, .em-featured-product__swatch-label, .em-featured-product__pill';

  function getSelectedOptions() {
    const selected = [];
    optionInputs.forEach((input) => {
      const idx = Number(input.dataset.optionIndex);
      if (input.checked) selected[idx] = input.value;
    });
    return selected;
  }

  function syncVariant() {
    const selected = getSelectedOptions();
    const match = variants.find((variant) =>
      variant.options.every((opt, idx) => opt === selected[idx])
    );

    if (match && variantInput) variantInput.value = match.id;

    if (match && priceEl) priceEl.textContent = formatEmMoney(match.price);
    if (match && stickyPriceEl) stickyPriceEl.textContent = formatEmMoney(match.price);

    const mediaId = mediaMap[match?.id] || match?.featured_media?.id;
    if (mediaId) showGalleryByMediaId(galleryRoot, mediaId);

    optionInputs.forEach((input) => {
      if (!input.checked) return;
      const label = el.querySelector(`[data-em-option-label="${input.dataset.optionIndex}"]`);
      if (label) label.textContent = input.dataset.displayLabel || input.value;
    });

    el.querySelectorAll(swatchSelectors).forEach((node) => {
      const input = node.querySelector('input');
      node.classList.toggle('is-selected', Boolean(input?.checked));
    });

    if (stickySubmit) {
      stickySubmit.disabled = match ? !match.available : true;
      stickySubmit.textContent = match?.available ? stickySubmit.dataset.label || 'Add to cart' : 'Sold out';
    }
  }

  optionInputs.forEach((input) => {
    input.addEventListener('change', syncVariant);
  });

  const qtyWrap = el.querySelector('[data-em-quantity]');
  if (qtyWrap) {
    const input = qtyWrap.querySelector('[data-em-qty-input]');
    qtyWrap.querySelector('[data-em-qty-minus]')?.addEventListener('click', () => {
      input.value = String(Math.max(1, Number(input.value) - 1));
    });
    qtyWrap.querySelector('[data-em-qty-plus]')?.addEventListener('click', () => {
      input.value = String(Number(input.value) + 1);
    });
  }

  if (stickyBar && stickySubmit) {
    const buyRow = el.querySelector('.em-product__buy-row');
    const defaultLabel = stickySubmit.textContent.trim();
    stickySubmit.dataset.label = defaultLabel;

    stickySubmit.addEventListener('click', () => {
      form.requestSubmit();
    });

    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.hidden = entry.isIntersecting;
      },
      { threshold: 0, rootMargin: '0px 0px -20px 0px' }
    );

    if (buyRow) observer.observe(buyRow);
  }

  syncVariant();
}

function initEarthMakerVideoCarousel(el) {
  if (el.dataset.emCarouselInit === 'true') return;
  el.dataset.emCarouselInit = 'true';

  const track = el.querySelector('[data-em-carousel-track]');
  const prev = el.querySelector('[data-em-carousel-prev]');
  const next = el.querySelector('[data-em-carousel-next]');
  if (!track) return;

  const scrollStep = () => Math.max(track.clientWidth * 0.75, 280);

  prev?.addEventListener('click', () => {
    track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
  });
  next?.addEventListener('click', () => {
    track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
  });

  el.querySelectorAll('[data-em-card-play]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const card = btn.closest('.em-video-carousel__card');
      const video = card?.querySelector('video');
      if (!video) return;
      if (video.paused) {
        video.play();
        btn.style.opacity = '0';
      } else {
        video.pause();
        btn.style.opacity = '1';
      }
    });
  });
}

function initEarthMakerSlideshow(el) {
  if (el.dataset.emInit === 'true') return;
  el.dataset.emInit = 'true';

  const slides = Array.from(el.querySelectorAll('[data-slide]'));
  const dots = Array.from(el.querySelectorAll('[data-dot]'));
  let index = 0;
  let timer = null;
  let progressFrame = null;
  let progressStart = 0;
  const autoplayMs = Number(el.dataset.autoplay) || 8000;
  const circumference = 62.83;

  function setProgress(elapsed) {
    const progress = Math.min(elapsed / autoplayMs, 1);
    dots.forEach((dot, idx) => {
      const circle = dot.querySelector('.em-slideshow__dot-progress');
      if (!circle) return;
      if (idx === index && dot.classList.contains('is-active')) {
        circle.style.strokeDashoffset = String(circumference * (1 - progress));
      } else {
        circle.style.strokeDashoffset = String(circumference);
      }
    });
  }

  function tickProgress(ts) {
    if (!progressStart) progressStart = ts;
    setProgress(ts - progressStart);
    if (ts - progressStart < autoplayMs) {
      progressFrame = requestAnimationFrame(tickProgress);
    }
  }

  function resetProgress() {
    if (progressFrame) cancelAnimationFrame(progressFrame);
    progressFrame = null;
    progressStart = 0;
    dots.forEach((dot) => {
      const circle = dot.querySelector('.em-slideshow__dot-progress');
      if (circle) circle.style.strokeDashoffset = String(circumference);
    });
  }

  function go(i) {
    if (!slides.length) return;
    index = ((i % slides.length) + slides.length) % slides.length;

    slides.forEach((slide, idx) => {
      slide.classList.toggle('is-active', idx === index);
      slide.setAttribute('aria-hidden', idx === index ? 'false' : 'true');
    });

    dots.forEach((dot, idx) => {
      dot.classList.toggle('is-active', idx === index);
      dot.setAttribute('aria-selected', idx === index ? 'true' : 'false');
    });

    resetProgress();
    progressFrame = requestAnimationFrame(tickProgress);
  }

  function next() {
    go(index + 1);
  }

  function start() {
    stop();
    if (slides.length > 1) {
      timer = window.setInterval(next, autoplayMs);
      progressFrame = requestAnimationFrame(tickProgress);
    }
  }

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
    resetProgress();
  }

  dots.forEach((dot, i) => dot.addEventListener('click', () => {
    go(i);
    start();
  }));

  el.querySelector('[data-next]')?.addEventListener('click', () => {
    const nextSection = el.closest('.shopify-section')?.nextElementSibling;
    nextSection?.scrollIntoView({ behavior: 'smooth' });
  });

  go(0);
  start();
  el.addEventListener('mouseenter', stop);
  el.addEventListener('mouseleave', start);
}

function getEarthMakerZoomLightbox() {
  let root = document.querySelector('[data-em-zoom]');
  if (root) return root;

  root = document.createElement('div');
  root.className = 'em-zoom';
  root.setAttribute('data-em-zoom', '');
  root.setAttribute('hidden', '');
  root.setAttribute('role', 'dialog');
  root.setAttribute('aria-modal', 'true');
  root.setAttribute('aria-label', 'Image preview');
  root.innerHTML = `
    <button type="button" class="em-zoom__close" data-em-zoom-close aria-label="Close preview">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="em-zoom__frame">
      <div class="em-zoom__stage" data-em-zoom-stage>
        <img class="em-zoom__img" data-em-zoom-img alt="">
      </div>
    </div>
    <div class="em-zoom__thumbs" data-em-zoom-thumbs hidden></div>
  `;
  document.body.appendChild(root);

  root.querySelector('[data-em-zoom-close]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    closeEarthMakerZoom();
  });

  root.addEventListener('click', (event) => {
    if (event.target === root) closeEarthMakerZoom();
  });

  root.querySelector('[data-em-zoom-thumbs]')?.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-em-zoom-thumb]');
    if (!thumb) return;
    event.stopPropagation();
    emZoomIndex = Number(thumb.dataset.emZoomThumb);
    renderEarthMakerZoom();
  });

  document.addEventListener('keydown', (event) => {
    if (root.hasAttribute('hidden')) return;
    if (event.key === 'Escape') closeEarthMakerZoom();
  });

  return root;
}

let emZoomSlides = [];
let emZoomThumbSrcs = [];
let emZoomIndex = 0;

function buildEarthMakerZoomThumbs() {
  const root = getEarthMakerZoomLightbox();
  const strip = root.querySelector('[data-em-zoom-thumbs]');
  if (!strip) return;

  if (emZoomSlides.length < 2) {
    strip.hidden = true;
    strip.innerHTML = '';
    return;
  }

  strip.hidden = false;
  strip.innerHTML = emZoomSlides
    .map((slide, idx) => {
      const src = emZoomThumbSrcs[idx] || slide.currentSrc || slide.src;
      const active = idx === emZoomIndex ? ' is-active' : '';
      return `<button type="button" class="em-zoom__thumb${active}" data-em-zoom-thumb="${idx}" aria-label="View image ${idx + 1}" aria-current="${idx === emZoomIndex ? 'true' : 'false'}"><img src="${src}" alt="" width="72" height="72" loading="lazy"></button>`;
    })
    .join('');

  const activeThumb = strip.querySelector('.em-zoom__thumb.is-active');
  activeThumb?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
}

function centerEarthMakerZoom() {
  const root = getEarthMakerZoomLightbox();
  const frame = root.querySelector('.em-zoom__frame');
  if (!frame) return;
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const maxX = Math.max(0, frame.scrollWidth - frame.clientWidth);
      const maxY = Math.max(0, frame.scrollHeight - frame.clientHeight);
      frame.scrollLeft = maxX / 2;
      frame.scrollTop = maxY / 2;
    });
  });
}

function renderEarthMakerZoom() {
  const root = getEarthMakerZoomLightbox();
  const slide = emZoomSlides[emZoomIndex];
  if (!slide) return;

  const img = root.querySelector('[data-em-zoom-img]');
  const src = slide.dataset.emZoomSrc || slide.currentSrc || slide.src;
  img.onload = () => centerEarthMakerZoom();
  img.src = src;
  img.alt = slide.alt || '';
  if (img.complete) centerEarthMakerZoom();
  buildEarthMakerZoomThumbs();
}

function openEarthMakerZoom(slides, index, thumbSrcs = []) {
  emZoomSlides = slides;
  emZoomThumbSrcs = thumbSrcs;
  emZoomIndex = index;
  const root = getEarthMakerZoomLightbox();
  renderEarthMakerZoom();
  root.removeAttribute('hidden');
  document.documentElement.classList.add('em-zoom-open');
  root.querySelector('[data-em-zoom-close]')?.focus({ preventScroll: true });
}

function closeEarthMakerZoom() {
  const root = document.querySelector('[data-em-zoom]');
  if (!root || root.hasAttribute('hidden')) return;
  root.setAttribute('hidden', '');
  document.documentElement.classList.remove('em-zoom-open');
  const img = root.querySelector('[data-em-zoom-img]');
  if (img) img.removeAttribute('src');
}

function initEarthMakerGallery(el) {
  if (el.dataset.emGalleryInit === 'true') return;
  el.dataset.emGalleryInit = 'true';

  const slides = Array.from(el.querySelectorAll('[data-em-gallery-slide]'));
  const thumbs = Array.from(el.querySelectorAll('[data-em-gallery-thumb]'));
  if (!slides.length) return;

  const thumbSrcs = slides.map((slide, idx) => {
    const thumbImg = thumbs[idx]?.querySelector('img');
    return thumbImg?.currentSrc || thumbImg?.src || slide.currentSrc || slide.src;
  });

  function show(i) {
    slides.forEach((slide, idx) => {
      const active = idx === i;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
    });
    thumbs.forEach((thumb, idx) => {
      thumb.classList.toggle('is-active', idx === i);
    });
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      show(Number(thumb.dataset.emGalleryThumb));
    });
  });

  slides.forEach((slide, index) => {
    slide.classList.add('em-gallery-zoomable');
    const open = () => openEarthMakerZoom(slides, index, thumbSrcs);
    slide.addEventListener('click', open);
    slide.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
      }
    });
  });
}

function initEarthMakerVideo(el) {
  if (el.dataset.emVideoInit === 'true') return;
  el.dataset.emVideoInit = 'true';

  const video = el.querySelector('.em-video__player');
  const toggle = el.querySelector('[data-em-video-toggle]');
  if (!video || !toggle) return;

  let playing = !video.paused;

  function sync() {
    toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    el.classList.toggle('is-playing', playing);
  }

  toggle.addEventListener('click', () => {
    if (playing) {
      video.pause();
      playing = false;
    } else {
      video.play();
      playing = true;
    }
    sync();
  });

  sync();
}

function initEarthMakerValueProps(el) {
  if (el.dataset.emValueInit === 'true') return;
  el.dataset.emValueInit = 'true';

  const track = el.querySelector('[data-em-value-track]');
  const dots = Array.from(el.querySelectorAll('[data-em-value-dot]'));
  const items = Array.from(el.querySelectorAll('.em-value-props__item'));
  if (!track || items.length <= 1) return;

  function go(i) {
    const item = items[i];
    if (!item) return;
    track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === i));
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => go(Number(dot.dataset.emValueDot)));
  });

  track.addEventListener('scroll', () => {
    const center = track.scrollLeft + track.clientWidth / 2;
    let closest = 0;
    let minDist = Infinity;
    items.forEach((item, idx) => {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const dist = Math.abs(center - itemCenter);
      if (dist < minDist) {
        minDist = dist;
        closest = idx;
      }
    });
    dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === closest));
  }, { passive: true });
}

function initEarthMakerReveal() {
  const items = document.querySelectorAll('[data-em-reveal]:not(.is-revealed)');
  if (!items.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach((item) => observer.observe(item));
}

function initAll(root = document) {
  root.querySelectorAll('[data-em-slideshow]').forEach(initEarthMakerSlideshow);
  root.querySelectorAll('[data-em-gallery]').forEach(initEarthMakerGallery);
  root.querySelectorAll('[data-em-video]').forEach(initEarthMakerVideo);
  root.querySelectorAll('[data-em-value-props]').forEach(initEarthMakerValueProps);
  root.querySelectorAll('[data-em-video-carousel]').forEach(initEarthMakerVideoCarousel);
  root.querySelectorAll('[data-em-product]').forEach(initEarthMakerProduct);
  initEarthMakerReveal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll());
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target);
});

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-em-popup]');
  if (!popup) return;

  const delay = Number(popup.dataset.delay || 5) * 1000;
  const key = 'em-popup-seen';
  if (sessionStorage.getItem(key)) return;

  setTimeout(() => {
    popup.classList.add('is-open');
    sessionStorage.setItem(key, '1');
  }, delay);

  popup.querySelector('[data-em-popup-close]')?.addEventListener('click', () => {
    popup.classList.remove('is-open');
  });

  popup.addEventListener('click', (e) => {
    if (e.target === popup) popup.classList.remove('is-open');
  });
});
